import { PlatformData } from "../Screens/Auth/OnboardingFlow/OnboardingSteps/components/PlatformTypes";

export interface SocialUrls {
  instagram?: string;
  youtube?: string;
  twitter?: string;
  tiktok?: string;
  linkedin?: string;
  newsletter?: {
    email: string;
    websiteLink?: string;
  };
  podcast?: {
    showUrl: string;
    showName: string;
    showId?: string;
  };
  website?: string;
  linkinbio?: string;
  amazon?: string;
  shopmy?: string;
  ltk?: string;
  facebook?: string;
  snapchat?: string;
  discord?: string;
}

export const generateSocialUrls = (platforms: PlatformData[]): SocialUrls => {
  const urls: SocialUrls = {};

  platforms.forEach((platform) => {
    if (!platform.username) return;

    switch (platform.platform.toLowerCase()) {
      case 'instagram':
        urls.instagram = `https://www.instagram.com/${platform.username}`;
        break;
      case 'youtube':
        // Handle both @username and channel URLs
        urls.youtube = `https://www.youtube.com/@${platform.username}`;
        break;
      case 'twitter':
        urls.twitter = `https://twitter.com/${platform.username}`;
        break;
      case 'tiktok':
        urls.tiktok = `https://www.tiktok.com/@${platform.username}`;
        break;
      case 'linkedin':
        urls.linkedin = `https://www.linkedin.com/in/${platform.username}`;
        break;
      case 'facebook':
        urls.facebook = `https://www.facebook.com/${platform.username}`;
        break;
      case 'amazon':
        urls.amazon = platform.username;
        break;
      case 'podcast':
        urls.podcast = {
          showUrl: platform.showUrl || '',
          showName: platform.username,
          showId: platform.showId
        };
        break;
      case 'newsletter':
        urls.newsletter = {
          email: platform.username,
          websiteLink: platform.websiteLink
        };
        break;
      case 'website':
        urls.website = platform.username.startsWith('http') 
          ? platform.username 
          : `https://${platform.username}`;
        break;
      case 'linkinbio':
        urls.linkinbio = platform.username;
        break;
      case 'shopmy':
        urls.shopmy = platform.username;
        break;
      case 'ltk':
        urls.ltk = platform.username;
        break;
      case 'snapchat':
        urls.snapchat = `https://www.snapchat.com/add/${platform.username}`;
        break;
      case 'discord':
        urls.discord = `https://discord.com/users/${platform.username}`;
        break;
    }
  });

  return urls;
}

// Example usage:
// const platforms = [
//   {
//     platform: "instagram",
//     username: "username"
//   },
//   {
//     platform: "youtube",
//     username: "username",
//     channelId: "UC..."
//   },
//   {
//     platform: "podcast",
//     username: "My Show Name",
//     showUrl: "https://...",
//     showId: "123"
//   }
// ];
// const socialUrls = generateSocialUrls(platforms); 